import { Component, OnInit } from '@angular/core';
import { UpcomingService } from './upcoming.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/shared/user/user.service';
import { DisplayService } from '../../../shared/display.service';
import { UrlService } from '../../../shared/url.service';

@Component({
  selector: 'app-upcoming',
  templateUrl: './upcoming.component.html',
  styleUrls: ['./upcoming.component.scss']
})
export class UpcomingComponent implements OnInit {

  upcomingData: any;
  dtOptions: DataTables.Settings = {};
  regionCodes: string[] = [];

  constructor(
    public displayService: DisplayService,
    private upcomingService: UpcomingService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    public urlService: UrlService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.dtOptions = {
      "order": [[0, "asc"]],
      "lengthChange": false,
      "searching": false,
      "paging": false,
      "info": false,
      "columnDefs": [
        { "orderable": false, "targets": 2 },
        { "orderable": false, "targets": 4 },
      ]
    };
    this.route.queryParams
      .subscribe(p => {
        if (p.regionCode) {
          this.regionCodes = this.regionCodes.concat(p.regionCode);
        } else {
          this.regionCodes = this.regionCodes.concat(this.userService.getRegions());
        }
        this.upcomingService.getUpcoming(this.regionCodes)
          .subscribe(data => {
            this.upcomingData = data;
          });
      });
  }

  getDocumentUrl(uniqueNumber: string): string {
    return this.urlService.getClientSiteUrl(uniqueNumber);
  }
}
